import { render } from "./StockTransfer.vue?vue&type=template&id=1d1a75cc&scoped=true"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"

import "./StockTransfer.vue?vue&type=style&index=0&id=1d1a75cc&scoped=true&lang=css"
import "./StockTransfer.vue?vue&type=style&index=1&id=1d1a75cc&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1a75cc"]])

export default __exports__